import { Component, OnInit, Input, ViewChild, Output} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Subject } from 'rxjs';

@Component({
  selector: 'eyrus-question-type-list',
  templateUrl: './question-type-list.component.html',
  styleUrls: ['./question-type-list.component.sass']
})
export class QuestionTypeListComponent implements OnInit {
  @ViewChild('addQuestion') addbuttonBottom: MatButton;

  @Output() optionSelected: Subject<any> = new Subject<any>()
  @Input() questionTypes: any[] = [];
  displayList: Boolean = false;

  constructor() { }

  ngOnInit() {
  }

  openHideList() {
    this.displayList = !this.displayList;

    setTimeout(() => {
      this.addbuttonBottom._elementRef.nativeElement.blur();
    }, 100);
  }

  setSelection(selection) {
    this.optionSelected.next(selection);
    this.displayList = false;
  }
}
